import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "./../common/table";
import Editor from "../components/common/Editor";

class WorkInstructionsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Component state for table functionality
    };
  }

  componentDidUpdate() {
    // Handle indeterminate state for header checkbox
    const headerCheckbox = document.querySelector('th input[type="checkbox"]');
    if (headerCheckbox && this.props.workInstructions.length > 0) {
      const checkedCount = this.props.workInstructions.filter(wi => 
        this.props.checkedFields.includes(wi._id)
      ).length;
      
      if (checkedCount === 0) {
        headerCheckbox.indeterminate = false;
        headerCheckbox.checked = false;
      } else if (checkedCount === this.props.workInstructions.length) {
        headerCheckbox.indeterminate = false;
        headerCheckbox.checked = true;
      } else {
        headerCheckbox.indeterminate = true;
        headerCheckbox.checked = false;
      }
    }
  }

  columns = [
    {
      key: "checkbox",
      label: (
        <input
          type="checkbox"
          style={checkboxStyles}
          onChange={this.props.toggle}
          ref={checkbox => {
            if (checkbox && this.props.workInstructions.length > 0) {
              const checkedCount = this.props.workInstructions.filter(wi => 
                this.props.checkedFields.includes(wi._id)
              ).length;
              
              if (checkedCount === 0) {
                checkbox.indeterminate = false;
                checkbox.checked = false;
              } else if (checkedCount === this.props.workInstructions.length) {
                checkbox.indeterminate = false;
                checkbox.checked = true;
              } else {
                checkbox.indeterminate = true;
                checkbox.checked = false;
              }
            }
          }}
        />
      ),
      content: (workInstruction) => (
        <span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
          <input
            type="checkbox"
            style={checkboxStyles}
            onChange={this.props.handleCheckboxChange}
            value={workInstruction._id}
            checked={this.props.checkedFields.includes(workInstruction._id)}
          />
        </span>
      ),
    },
    {
      label: "Owner",
      path: "user",
      content: (workInstruction) => (
        <span className="icon-img sm-r-5">
          {/* User Avatar */}
          {workInstruction?.user?.imageSrc && (
            <img
              style={{ width: "20px", height: "20px", borderRadius: "50%", marginRight: "4px" }}
              src={workInstruction?.user?.imageSrc}
              alt="User Avatar"
            />
          )}
          {workInstruction?.user?.contactName?.first} {workInstruction?.user?.contactName?.last}
        </span>
      ),
    },
    { 
      label: "Department", 
      path: "department" 
    },
    {
      label: "Name",
      path: "name"
    },
    {
      label: "Description",
      path: "description",
      content: (workInstruction) => {
        if (!workInstruction.description) return "-";
        return workInstruction.description.length > 50 
          ? workInstruction.description.substring(0, 50) + "..."
          : workInstruction.description;
      }
    },
    { 
      label: "Tags", 
      path: "tags" 
    },
    { 
      label: "Version", 
      path: "version" 
    },
    {
      label: "Business Name",
      path: "businessNo",
      content: (workInstruction) => {
        // Try the companyinfo path first, then fallback to other paths
        // const businessLogo = workInstruction?.companyinfo?.companies?.imageSrc || 
        //                    workInstruction?.companyinfo?.imageSrc || 
        //                    workInstruction?.businessNo?.companyInfo?.businessLogo || 
        //                    workInstruction?.businessNo?.businessLogo || 
        //                    workInstruction?.businessNo?.logo || 
        //                    workInstruction?.businessNo?.companyInfo?.logo ||
        //                    workInstruction?.businessNo?.image ||
        //                    workInstruction?.businessNo?.companyInfo?.image;
        
            const businessLogo = workInstruction?.businessNo?.user?.imageSrc || 
                           workInstruction?.businessNo?.logo;

        
        return (
          <span className="icon-img sm-r-5">
            {/* Business Logo */}
            {businessLogo ? (
              <img
                style={{ width: "20px", height: "20px", borderRadius: "50%", marginRight: "4px" }}
                src={businessLogo}
                alt="Business Logo"
                onError={(e) => {
                  // Image failed to load, hide it
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div
                style={{ 
                  width: "20px", 
                  height: "20px", 
                  borderRadius: "50%", 
                  backgroundColor: "#28a745",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "4px",
                  fontSize: "10px",
                  color: "white"
                }}
              >
                <i className="fa fa-building"></i>
              </div>
            )}
            {workInstruction?.businessNo?.companyInfo?.businessName || 
             'No Business'}
          </span>
        );
      },
    },
    {
      label: "Actions",
      path: "actions",
      content: (workInstruction) => {
        if (!workInstruction.actions || !Array.isArray(workInstruction.actions)) {
          return "No actions";
        }
        
        // If actions are populated objects with action details
        if (workInstruction.actions.length > 0 && typeof workInstruction.actions[0] === 'object') {
          return workInstruction.actions.map((action, index) => (
            <span key={action._id || index}>
              {action?.name || 'Unnamed Action'}
              {index !== workInstruction.actions.length - 1 ? ", " : ""}
            </span>
          ));
        }

        // if (workInstruction.actions.length > 0 && typeof workInstruction.actions[0] === 'object') {
        //   return workInstruction.actions.map((action, index) => (
        //     <span key={action._id || index}>
        //       <Editor
        //         initialContent={action.name}
        //         readOnly={true}
        //       />
        //       {index !== workInstruction.actions.length - 1 ? " " : ""}
        //     </span>
        //   ));
        // }
        
        // If actions are just ObjectIds (not populated)
        return `${workInstruction.actions.length} action(s)`;
      },
    },
    { 
      label: "Language", 
      path: "language" 
    },
    { 
      label: "Note", 
      path: "note" 
    },
    {
      label: "Created On",
      path: "createdOn",
      content: (workInstruction) => {
        if (!workInstruction.createdOn) {
          return <span>N/A</span>;
        }
        
        try {
          const date = new Date(workInstruction.createdOn);
          // Check if date is valid
          if (isNaN(date.getTime())) {
            return <span>Invalid Date</span>;
          }
          
          // Format date with both date and time
          const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
          
          const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          });
          
          return (
            <span>
              {formattedDate}<br />
              {formattedTime}
            </span>
          );
        } catch (error) {
          return <span>Error</span>;
        }
      },
    },
    {
        label: "Status",
        path: "status",
        content: (workInstruction) => (
          <span>
            {workInstruction.status || "active"}
          </span>
        ),
      }
  ];
  
  render() {
    const { workInstructions, onSort, sortColumn } = this.props;
    
    if (workInstructions.length === 0) {
      return (
        <div className="alert alert-info">
          No work instructions found. <Link to="/workinstructions/workinstructions/new">Create one now</Link>
        </div>
      );
    }

    return (
      <Table
        columns={this.columns}
        sortColumn={sortColumn}
        onSort={onSort}
        data={workInstructions}
      />
    );
  }
}

const checkboxStyles = {
  width: "15px",
  height: "15px",
  marginTop: "0.4rem",
  borderRadius: 0,
};

export default WorkInstructionsTable;
